export default "__VITE_ASSET__Di02o9JG__"